<template>
  <div class="baniere">
    <popupProject
      :want-to-make-offer="activeProjet"
      @oga="retourProjet"
    />
    <div class="md:mt-16">
      <div
        class="titre"
        data-aos="fade-up"
        data-aos-duration="2000"
      >
        Explorez des solutions dans le but d’améliorer les expériences, les perspectives et les soins
      </div>

      <div class="w-full md:flex flex-wrap md:mt-20 mt-6">
        <div
          class="ok md:mr-10"
          data-aos="fade-right"
          data-aos-duration="2000"
        >
          <div class="w-full image">
            <img
              src="../../../assets/images/jpg/soin.jpg"
              alt=""
            >
          </div>
          <div class="nom p-8">
            Soins personnalisés mis en place
          </div>
        </div>

        <div
          class="ok mr-10"
          data-aos="fade-up"
          data-aos-duration="2000"
        >
          <div class="w-full image">
            <img
              src="../../../assets/images/jpg/piqure.jpg"
              alt=""
            >
          </div>
          <div class="nom p-8">
            Renforcer les moyens des équipes soignantes
          </div>
        </div>

        <div
          class="ok"
          data-aos="fade-left"
          data-aos-duration="2000"
        >
          <div class="w-full image">
            <img
              src="../../../assets/images/jpg/massage.jpg"
              alt=""
            >
          </div>
          <div class="nom p-8">
            Améliorer les résultats opérationnels
          </div>
        </div>

        <div
          class="ok mr-10"
          data-aos="fade-right"
          data-aos-duration="2000"
        >
          <div class="w-full image">
            <img
              src="../../../assets/images/jpg/ste.jpg"
              alt=""
            >
          </div>
          <div class="nom p-8">
            Réinventer les soins de santé
          </div>
        </div>

        <div
          class="ok"
          data-aos="fade-up"
          data-aos-duration="2000"
        >
          <div class="w-full image">
            <img
              src="../../../assets/images/jpg/numerique.jpg"
              alt=""
            >
          </div>
          <div class="nom p-8">
            Protéger les informations médicales
          </div>
        </div>
      </div>

      <div
        class="flex justify-center w-full pb-20"
        data-aos="fade-up"
        data-aos-duration="2000"
      >
        <div
          class="button md:mt-6 mt-12 md:w-1/5 w-4/5 mb-4"
          @click="openProjet"
        >
          Demander une démo
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import popupProject from '@/components/popup/popupProject'

export default {
  name: 'Index',
  components: {
    popupProject
  },
  props: {
  },
  data () {
    return {
      activeProjet: false
    }
  },
  created () {
  },
  methods: {
    openProjet () {
      this.activeProjet = true
    },

    retourProjet (answer) {
      this.activeProjet = answer
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/style/sass/variables";
.baniere{
  height: auto ;
  background-color: $white;
  position: relative;
  padding-left: $padding-l;
  padding-right: $padding-r;
}
.titre{
  font-weight: bold;
  font-size: 60px;
  line-height: 160%;
  text-align: center;
  letter-spacing: 0.01em;
  color: $black;
}
.ok{
  width: 30%;
  margin-bottom: 70px;
  background: #FBFCFE;
  border: 2px solid $background-gray-dev;
  box-sizing: border-box;
}
.nom{
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 29px;
  color: #000000;
}

.button{
  background-color: $dev-green;
  height: 60px;
  border-radius: 0px;
  border: none;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 29px;
  color: white;
}

@media screen and (max-width: 600px){
  .baniere{
    padding-left: 10px;
    padding-right: 10px;
  }
  .titre{
    font-size: 28px;
  }
  .bloc1{
    width: 100%;
  }
  .bloc2{
    width: 100%;
    font-size: 18px;
  }

  .title3{
    font-size: 18px;
  }
  .ok{
    width: 100%;
    margin-bottom: 20px;
  }
}
@media screen and (min-width: 701px) and (max-width: 1024px){
  .baniere{
    padding-left: $padding-l-1024;
    padding-right: $padding-r-1024;
  }
  .titre{
    font-size: 50px;
  }
  .titre3{
    font-size: 20px;
  }
  .nom{
    font-size: 18px;
  }
  .button{
    width: 30%;
  }
}
</style>
